/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateOrderPaymentIntentMutationVariables = Types.Exact<{
  input: Types.CreateOrderPaymentIntentInput;
}>;

export type CreateOrderPaymentIntentMutation = {
  readonly __typename?: 'Mutation';
  readonly createOrderPaymentIntent: {
    readonly __typename: 'PaymentIntent';
    readonly id: string;
    readonly secret: string;
  };
};

export const CreateOrderPaymentIntentDocument = gql`
  mutation CreateOrderPaymentIntent($input: CreateOrderPaymentIntentInput!) {
    createOrderPaymentIntent(input: $input) {
      __typename
      id
      secret
    }
  }
`;

export function useCreateOrderPaymentIntentMutation() {
  return Urql.useMutation<
    CreateOrderPaymentIntentMutation,
    CreateOrderPaymentIntentMutationVariables
  >(CreateOrderPaymentIntentDocument);
}
